import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">Mojifi</Link>
            <p>Mojifi any image using ChatGPT</p>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/instructions">Instructions</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/community">X Community</Link></li>
            </ul>
          </div>
          
          <div className="footer-social">
            <h3>Connect With Us</h3>
            <div className="social-icons">
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <img src="/images/xicon.png" alt="X (Twitter)" className="social-icon-img" />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon-link">
                <img src="/images/tgicon.png" alt="Telegram" className="social-icon-img" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Mojifi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 